import React from 'react'
import ContentBox from '../../CaseStudy/sub-components/ContentBox'

function Duai() {
    return (
        <div className=''>


            <div >


                <ContentBox
                    blockText="Du is a major telecommunications provider in UAE. it offers a wide range of services. These include mobile services such as prepaid and postpaid plans, internet services like high-speed home broadband and Wi-Fi solutions for residential and business use. In addition, du delivers TV services, including IPTV with access to regional and international channels, as well as on-demand streaming and entertainment bundles."
                />





            </div>

        </div>

    )
}

export default Duai